/**
 * Represents a welcome flow specific instance of a consumer
 */
export interface IWelcomeFlowConsumer
{
    consumerId: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    mobileVerified: boolean;
}

/**
 * Represents a welcome flow specific instance of a vehicle
 */
export interface IWelcomeFlowVehicle
{
    vehicleId?: string;
    app: ICarbucksAppTile;
    rego?: string;
    regoState?: string;
    odometer?: number;
    make?: string;
    model?: string;
    variant?: string;
    year?: number;
    lastCompletedStep?: WelcomeFlowProgress;
    appSelected?: boolean;
    verified?: boolean;
    isEligibleToCompleteWelcomeFlow?: boolean;
}

/**
 * Contains the welcome flow data required for an app configuration
 */
export interface ICarbucksAppTile
{
    appConfigurationId?: string;
    dealershipName?: string;
    name?: string;
    logoUrl?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    postcode?: string;
}

/**
 * Represents the different panels of the welcome flow
 * these are used to control which tab panel is currently displayed
 * @enum {string}
 */
export enum WelcomeFlowPanel
{
    FindVehicle = 'find-vehicle',
    GettingCarReady = 'getting-car-ready',
    LoadingPanel = 'loading',
    ErrorPanel = 'error'
    // OriginatorCode = 'originator-code',
    // SelectApp = 'select-app',
    // ContactDetails = 'contact-details',
    // VerifyMobile = 'verify-mobile'
}

/**
 * Represents the options for loading a panel
 */
export interface IPanelLoadOptions {
    /** Messages to display if navigating to the loading panel */
    loadingMessages?: string[];
    /** Minimum time in milliseconds to display the loading panel */
    minimumTime?: number;
}

/**
 * Represents the different steps of the welcome flow
 * used to track the consumers progress through the welcome flow
 */
export enum WelcomeFlowProgress
{
    NotStarted = 0,
    VehicleClaimed = 1,
    AppSelected = 2,
    DetailsConfirmed = 3,
    MobileVerified = 4,
    Complete = 5
}